<div class="d-flex flex-column flex-md-row align-items-center justify-content-between bgcolor-main2">
  <span class="text-white mt-5 mt-md-0 ms-md-4 ps-md-5 mb-4 mb-md-1">© 2024 <span class="color-secondary">JandroDev</span></span>
  <img src="assets/logos/logo.svg" alt="Logo Footer" class="img-fluid ms-md-5 ps-md-5 mb-md-0 svgBlanco" width="140em">
  <div class="redesSociales d-flex flex-wrap justify-content-center ms-2 mb-0">
    <a class="contenedorRS redSocial" href="https://github.com/jandro-dev" target="_blank">
      <img src="assets/socials/github.svg" alt="Github" class="imagenRS svgBlanco">
    </a>
    <a class="contenedorRS redSocial" href="https://twitter.com/jandro_dev" target="_blank">
      <img src="assets/socials/x.svg" alt="X" class="imagenRS svgBlanco">
    </a>
    <a class="contenedorRS redSocial" href="https://www.instagram.com/jandro_dev/" target="_blank">
      <img src="assets/socials/instagram.svg" alt="Instagram" class="imagenRS svgBlanco">
    </a>
    <a class="contenedorRS redSocial" href="https://es.linkedin.com/in/alejandro-fp" target="_blank">
      <img src="assets/socials/linkedin.svg" alt="Linkedin" class="imagenRS svgBlanco">
    </a>
  </div>
</div>